import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { useAllocationChartContext } from '~/modules/projects/resourcing-plan/ResourcingPlanPage/contexts';
import { useBulkMarkResourceRequestsAsComplete } from '../hooks';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(0.5, 2),
    borderRadius: theme.spacing(2.5),
    color: theme.palette.common.white,
    boxShadow: 'none'
  },
  text: {
    textTransform: 'uppercase'
  }
}));

export const ResourceRequestProposeAcceptAllButton = ({
  proposedResourceRequests
}) => {
  const classes = useStyles();
  const { allocationChartRef } = useAllocationChartContext();

  const {
    bulkMarkResourceRequestsAsComplete
  } = useBulkMarkResourceRequestsAsComplete();

  const handleProposeAll = useCallback(() => {
    bulkMarkResourceRequestsAsComplete({
      proposedResourceRequests,
      allocationChartRef
    });
  }, [
    bulkMarkResourceRequestsAsComplete,
    proposedResourceRequests,
    allocationChartRef
  ]);

  return (
    <Button
      className={classes.root}
      onClick={handleProposeAll}
      variant="contained"
      color="primary"
    >
      <FormattedMessage
        className={classes.text}
        id="resourceRequestChartBanner.acceptAll"
      />
    </Button>
  );
};

ResourceRequestProposeAcceptAllButton.propTypes = {
  proposedResourceRequests: PropTypes.array.isRequired
};

export default ResourceRequestProposeAcceptAllButton;
